module.exports = __webpack_public_path__ + "media/svg/vc-18402a16.svg";